export const NAME_FIELD = 'name';
export const PROFILE_NAME_FIELD = 'profileName';
export const NETWORK_NAME_FIELD = 'networkName';
export const DESCRIPTION_FIELD = 'description';
export const AUTH_TYPE_FIELD = 'authType';
export const EAP_TYPE_FIELD = 'eapType';
export const AUTH_CERTIFICATE_FIELD = 'authCertificate';
export const PSK_FIELD = 'psk';
export const USERNAME_FIELD = 'username';
export const PASSWORD_FIELD = 'password';
export const IS_DEFAULT_FIELD = 'isDefault';
export const AGENTS_FIELD = 'agents';

export const IS_ACTIVE_DIRECTORY_DOMAIN_FIELD = 'isUsingAD';
export const ACTIVE_DIRECTORY_FQDN_FIELD = 'adFQDN';
export const ACTIVE_DIRECTORY_SERVERIP_FIELD = 'adServerIP';

export const AUTH_TYPE_TRANSLATED_FIELD = 'authTypeTranslated';
export const IS_DEFAULT_TRANSLATED_FIELD = 'isDefaultTranslated';
export const CONFIGURED_AGENTS_COUNT_FIELD = 'configuredAgentsCount';
export const CONNECTED_AGENTS_COUNT_FIELD = 'connectedAgentsCount';

export const SSID_TYPE_OPEN_OPTION = 'OPEN';
export const SSID_TYPE_OWE_OPTION = 'OWE';
export const SSID_TYPE_WPA_P_OPTION = 'WPA-P';
export const SSID_TYPE_WPA_E_OPTION = 'WPA-E';

export const SSID_TYPE_OPEN_TEXT = 'Open';
export const SSID_TYPE_OWE_TEXT = 'OWE';
export const SSID_TYPE_WPA_P_TEXT = 'WPA/WPA2/WPA3 Personal';
export const SSID_TYPE_WPA_E_TEXT = 'WPA/WPA2/WPA3 Enterprise';

export const AUTH_TYPE_OPTIONS = {
    [SSID_TYPE_OPEN_OPTION]: SSID_TYPE_OPEN_TEXT,
    [SSID_TYPE_OWE_OPTION]: SSID_TYPE_OWE_TEXT,
    [SSID_TYPE_WPA_P_OPTION]: SSID_TYPE_WPA_P_TEXT,
    [SSID_TYPE_WPA_E_OPTION]: SSID_TYPE_WPA_E_TEXT,
};

export const EAP_TYPE_OPTIONS = {
    eapTls: 'EAP-TLS',
    eapFast: 'EAP-FAST',
    peapGtc: 'PEAP-GTC',
    peapMschapV2: 'PEAP-MSCHAP-V2',
    ttlsPap: 'TTLS-PAP',
    ttlsChap: 'TTLS-CHAP',
    ttlsMchap: 'TTLS-MSCHAP',
    ttlsMchapV2: 'TTLS-MSCHAP-V2',
};

export const AUTH_CERTIFICATE_DEFAULT_OPTION = 'None';

export const NETWORKS_IN_USE_ERROR = 'network_in_use';
